import React, { forwardRef } from 'react';
import ProblemCard from './ProblemCard';
import { Problem } from './types';

interface CarouselTrackProps {
  items: Problem[];
  activeIndex: number;
  onScroll: () => void;
  onItemClick: (index: number) => void;
}

const CarouselTrack = forwardRef<HTMLDivElement, CarouselTrackProps>(
  ({ items, activeIndex, onScroll, onItemClick }, ref) => {
    return (
      <div
        ref={ref}
        onScroll={onScroll}
        className="flex overflow-x-auto scrollbar-hide gap-6 pb-8 pt-2 snap-x snap-mandatory px-4 md:px-0 scroll-smooth"
        style={{
          scrollSnapType: 'x mandatory',
          scrollBehavior: 'smooth',
          msOverflowStyle: 'none',  /* IE and Edge */
          scrollbarWidth: 'none'    /* Firefox */
        }}
      >
        {/* Initial spacer for centering */}
        <div className="flex-shrink-0 w-[calc(50%-160px)] md:w-[calc(50%-200px)]" aria-hidden="true" />

        {items.map((item, index) => (
          <div
            key={index}
            className="flex-shrink-0 snap-center"
          >
            <ProblemCard
              icon={item.icon}
              title={item.title}
              points={item.points}
              isActive={index === activeIndex}
              onClick={() => onItemClick(index)}
            />
          </div>
        ))}

        {/* Final spacer for centering */}
        <div className="flex-shrink-0 w-[calc(50%-160px)] md:w-[calc(50%-200px)]" aria-hidden="true" />
      </div>
    );
  }
);

CarouselTrack.displayName = 'CarouselTrack';

export default CarouselTrack;